import { render, staticRenderFns } from "./ComponentPage.vue?vue&type=template&id=4315fe41&scoped=true"
import script from "./ComponentPage.vue?vue&type=script&lang=ts"
export * from "./ComponentPage.vue?vue&type=script&lang=ts"
import style0 from "./ComponentPage.vue?vue&type=style&index=0&id=4315fe41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4315fe41",
  null
  
)

export default component.exports